import React, { FC } from 'react'
import dynamic from 'next/dynamic'
import { MessageIcon } from '../icons'

const InfoBox2 = dynamic(() => import('../components/Boxes/InfoBox2'))

interface Props {
  title: string
  boldTitle: string
  description: string
  boldDescription: string
  action: string
  actionTitle: string
  href?: string
}

const InfoBoxContainer2: FC<Props> = ({ title, boldTitle, description, boldDescription, action, actionTitle, href }) => (
  <InfoBox2
    title={title}
    boldTitle={boldTitle}
    description={description}
    boldDescription={boldDescription}
    action={action}
    actionTitle={actionTitle}
    href={href || '/page-here'}
    icon={<MessageIcon />}
  />
)

export default InfoBoxContainer2
